/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Map_UrlInputs */

const vi_shop_home_map_url = /** @type {(inputs: Shop_Home_Map_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link bản đồ`)
};

/**

* @param {Shop_Home_Map_UrlInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_map_url = /** @type {((inputs?: Shop_Home_Map_UrlInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Map_UrlInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_map_url(inputs)
});